import { Injectable, signal } from '@angular/core';

const MUTE_DURATION_MS = 15_000;

@Injectable({
  providedIn: 'root',
})
export class SessionExpirationService {
  private readonly expiredState = signal(false);
  private muteTimeoutId: ReturnType<typeof setTimeout> | null = null;

  readonly expired = this.expiredState.asReadonly();

  markExpired(): void {
    this.expiredState.set(true);
    this.clearMuteTimeout();
    this.muteTimeoutId = setTimeout(() => this.reset(), MUTE_DURATION_MS);
  }

  reset(): void {
    this.clearMuteTimeout();
    this.expiredState.set(false);
  }

  private clearMuteTimeout(): void {
    if (this.muteTimeoutId !== null) {
      clearTimeout(this.muteTimeoutId);
      this.muteTimeoutId = null;
    }
  }
}
